import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useValidateUserExistByEmail = () => {
  const mutation = useMutation((formData) => {
    return axiosClient.post("User/ValidateUserExistByEmail", formData);
  });
  return mutation;
};
export default useValidateUserExistByEmail;
